import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useHeroStyles } from './HeroSection.styles';
import HeroVisual from './HeroVisual';
import { fadeUp, stagger } from '../../../../styles/animations';

const HeroSection = () => {
    const { classes } = useHeroStyles();

    return (
        <Box component="section" className={classes.section} id="top">
            <Box className={classes.inner}>
                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={stagger(0.12, 0.1)}
                >
                    <motion.div variants={fadeUp} className={classes.eyebrow}>
                        <Typography variant="overline">
                            Digital Strategy &amp; Technology
                        </Typography>
                    </motion.div>

                    <motion.div variants={fadeUp}>
                        <Typography variant="display1" component="h1" className={classes.headline}>
                            Technology that moves<br />business forward.
                        </Typography>
                    </motion.div>

                    <motion.div variants={fadeUp}>
                        <Typography variant="subtitle1" className={classes.subCopy} sx={{ color: 'fog' }}>
                            Nexora helps ambitious companies transform complex digital
                            challenges into scalable technology.
                        </Typography>
                    </motion.div>

                    <motion.div variants={fadeUp} className={classes.ctaRow}>
                        <Button variant="contained" href="#contact" sx={{ backgroundColor: 'common.white', color: 'ink.main', '&:hover': { backgroundColor: 'fog' } }}>
                            Start a project
                        </Button>
                        <a href="#work" className={classes.secondaryLink}>Explore our work</a>
                    </motion.div>
                </motion.div>

                <Box className={classes.visual}>
                    <HeroVisual />
                </Box>
            </Box>
        </Box>
    );
};

export default HeroSection;
